import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Button,
  Input,
  Col, // Importamos el componente Input de Reactstrap
} from "reactstrap";
import Header from "components/Headers/Header.js";
import AdjuntosCargadosIndex from "components/Ordenes/AdjuntosCargadosIndex";
import EquiposIntaladosInspec from "./EquiposIntaladosInspec";
import Resultados from "./Resultados";
import InfoVehiculo from "./InfoVehiculo";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import { FaClipboardCheck, FaPencilRuler } from "react-icons/fa";
import InspectorTaller from "components/Ordenes/InspectorTaller";
import CreaComentarios from "views/Crea/CreaComentarios";
import ProtectedRoute from "./Protected";

const Ordenes = () => {
  const cookie = new Cookies();
  let urlendpoint;
  const tipoUsuarioId = cookie.get("tipoUsuarioId");

  useEffect(() => {
    if (!tipoUsuarioId) {
      Swal.fire({
        icon: "warning",
        title: "Debe iniciar sesión",
        text: "Por favor, inicie sesión para continuar.",
        confirmButtonText: "Aceptar",
      }).then(() => {
        window.location.href = "/auth/login";
      });
    }
  }, [tipoUsuarioId]);

  if (tipoUsuarioId == "1") {
    urlendpoint =
      "https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerOrdenesAbiertas/0";
  } else if (tipoUsuarioId == "2") {
    urlendpoint = `https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerOrdenesAbiertas/${cookie.get(
      "id",
    )}`;
  } else if (tipoUsuarioId == "3") {
    urlendpoint = `https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerOrdenesAbiertas/${cookie.get(
      "id",
    )}`;
  } else {
    urlendpoint = null;
  }

  const [list1, setList1] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [list, setList] = useState([]);
  const [searchTerm, setSearchTerm] = useState(""); // Añadir estado para el término de búsqueda

  useEffect(() => {
    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url: `https://inspecciongnvback.azurewebsites.net/api/v1/LogueoActivo/${cookie.get(
        "id",
      )}`,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    const cached = localStorage.getItem("ordenesData");
    if (cached) {
      setList1(JSON.parse(cached));
    }
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(urlendpoint);
      setList1(response.data);
      localStorage.setItem("ordenesData", JSON.stringify(response.data));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  useEffect(() => {
    fetchData();
  }, []);

  const handleClick = (e, index) => {
    e.preventDefault();
    setCurrentPage(index);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const filteredItems = list1.filter((item) =>
    Object.values(item).some((val) =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase()),
    ),
  );

  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const Crear = (e) => {
    window.location.href = "/admin/CreaPropitario";
  };

  return (
    <ProtectedRoute>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">ORDENES DE SERVICIO</h3>
              </CardHeader>
              {tipoUsuarioId == 3 ? (
                <Button
                  variant="contained"
                  className="btn btn-primary btn-lg"
                  color="primary"
                  onClick={Crear}
                >
                  Nuevo
                </Button>
              ) : (
                <h></h>
              )}

              <Row>
                <Col className="order-xl-2" xl="6">
                  <Input
                    type="text"
                    placeholder="Buscar..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="mt-3"
                  />
                </Col>
              </Row>
              <hr />
              <Table
                className="align-items-center table-lght table-flush"
                responsive
              >
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Id</th>
                    <th scope="col">Vehiculo</th>
                    <th scope="col">Placa</th>
                    <th scope="col">Fecha Pestación del servicio</th>
                    <th scope="col">Fecha Creación</th>
                    <th scope="col">Taller</th>
                    <th scope="col">Tipo Orden Servicio</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Usuario Id</th>
                    <th scope="col">Chip Vehiculo</th>
                    <th scope="col">Chip Taller</th>
                    <th scope="col">Fecha Conversión</th>
                    {cookie.get("tipoUsuarioId") != "3" ? (
                      <th scope="col">Lista</th>
                    ) : (
                      <h></h>
                    )}
                    <th scope="col">Anexos</th>
                    <th scope="col">Equipos</th>
                    <th scope="col">Editar </th>

                    {cookie.get("tipoUsuarioId") != 3 ? (
                      <th scope="col">Comentarios </th>
                    ) : (
                      <h></h>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(currentItems) &&
                    currentItems.map((item) => {
                      const handleVolverClick = () => {
                        window.location.href =
                          "/admin/PresentaLista/" +
                          item.listaChequeoId +
                          "/" +
                          item.id;
                      };
                      const Edicion = () => {
                        window.location.href = "/admin/EditaOrden/" + item.id;
                      };
                      const EdicionChip = () => {
                        window.location.href = "/admin/EdicionChip/" + item.id;
                      };

                      return (
                        <tr key={item.id}>
                          <td>{item.id}</td>
                          <td>
                            <InfoVehiculo vehiculoId={item.vehiculoId} />
                          </td>
                          <td>{item.placa}</td>
                          <td>{item.fechaPrestacionServicio}</td>
                          <td>{item.fechaCreacion}</td>
                          <td>{item.nombreTaller}</td>
                          <td>{item.toservicio}</td>
                          <td>{item.estado}</td>
                          <td>{item.correo}</td>
                          <td>{item.chipVehiculo}</td>
                          <td>{item.chipTaller}</td>
                          <td>{item.fechaConversion}</td>
                          {item.estado == "Presentado" ? (
                            cookie.get("tipoUsuarioId") != "3" ? (
                              <td>
                                <Resultados
                                  OrdenId={item.id}
                                  vehiculoId={item.vehiculoId}
                                />
                              </td>
                            ) : (
                              <td></td>
                            )
                          ) : item.estado == "Rechazado" ? (
                            <td>
                              {cookie.get("tipoUsuarioId") != "3" ? (
                                <Button
                                  className="btn btn-warning btn-lg"
                                  color="primary"
                                  onClick={handleVolverClick}
                                  title="No disponible Rechazado"
                                  disabled
                                >
                                  <FaClipboardCheck
                                    style={{ marginRight: "0px" }}
                                  />
                                </Button>
                              ) : null}
                            </td>
                          ) : cookie.get("tipoUsuarioId") != "3" ? (
                            <td>
                              <Button
                                className="btn btn-info btn-lg"
                                color="primary"
                                onClick={handleVolverClick}
                                title="presentar lista"
                              >
                                <FaClipboardCheck
                                  style={{ marginRight: "0px" }}
                                />
                              </Button>
                            </td>
                          ) : (
                            <h></h>
                          )}
                          <td>
                            <AdjuntosCargadosIndex OrdenId={item.id} />
                          </td>
                          <td>
                            <EquiposIntaladosInspec OrdenId={item.id} />
                          </td>
                          {item.estado !== "Presentado" ? (
                            <>
                              {/* Cuando es 9 o 8→ SOLO botón azul */}
                              {[9, 8].includes(item.tipoOrdenServicioId) ? (
                                <td>
                                  <Button
                                    className="btn btn-info btn-lg"
                                    color="info"
                                    onClick={() => EdicionChip(item)}
                                    title="Edición cambios de chip"
                                  >
                                    <FaPencilRuler />
                                  </Button>
                                </td>
                              ) : (
                                /* Cuando NO es 9 ni 10 → botón amarillo */
                                <td>
                                  <Button
                                    className="btn btn-warning btn-lg"
                                    color="primary"
                                    onClick={() => Edicion(item)}
                                    title="Editar toda la solicitud"
                                  >
                                    <FaPencilRuler />
                                  </Button>
                                </td>
                              )}
                            </>
                          ) : (
                            <td>
                              <Button
                                className="btn btn-warning btn-lg"
                                color="primary"
                                disabled
                              >
                                <FaPencilRuler />
                              </Button>
                            </td>
                          )}
                          {cookie.get("tipoUsuarioId") != 3 ? (
                            <td>
                              <CreaComentarios OrdenId={item.id} />
                            </td>
                          ) : (
                            <h></h>
                          )}
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination className="pagination justify-content-end mb-0">
                    <PaginationItem disabled={currentPage <= 1}>
                      <PaginationLink
                        previous
                        onClick={(e) => handleClick(e, currentPage - 1)}
                      />
                    </PaginationItem>

                    {/* Muestra el texto "Página X de N" */}
                    <PaginationItem disabled>
                      <PaginationLink>
                        Página {currentPage} de{" "}
                        {Math.ceil(filteredItems.length / itemsPerPage)}
                      </PaginationLink>
                    </PaginationItem>

                    <PaginationItem
                      disabled={
                        currentPage >=
                        Math.ceil(filteredItems.length / itemsPerPage)
                      }
                    >
                      <PaginationLink
                        next
                        onClick={(e) => handleClick(e, currentPage + 1)}
                      />
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
      {cookie.get("tipoUsuarioId") == "2" && list == false ? (
        <InspectorTaller />
      ) : (
        <h></h>
      )}
    </ProtectedRoute>
  );
};

export default Ordenes;
